import React from 'react'
import { hooks } from '@front/volcanion'
import { BillingUtils } from '@front/volcanion/utils'

const withContainer = Component => props => {
  const [hasJobPayment] = hooks.useFormState('hasJobPayment')
  const [transport_id] = hooks.useFormState('transport_id')
  const [order_id] = hooks.useFormState('record_id')
  const [{ discount_percent: driver_discount_percent }] = hooks.useOrderDiscount(order_id, 'driver')
  const [{ discount_percent: customer_discount_percent }] = hooks.useOrderDiscount(order_id, 'customer')

  const [order] = hooks.useModel('order', [order_id], { populate: ['specific_parameter'], single: true })

  const [driver_payment, client_payment] = hooks.useFieldValues(['job.payment', 'assigned_transport.payment'])
  const calculated_driver_total = BillingUtils.getPaymentDisplay(_.mapValues(driver_payment, _.toNumber), true, 2, false)
  const calculated_client_total = BillingUtils.getPaymentDisplay(_.mapValues(client_payment, _.toNumber), true, 2, false)

  const markup_percentage = order?.specific_parameter?.markup_percentage

  const mergedProps = {
    col1: { disabled: !hasJobPayment, markup_percentage, calculated_driver_total, driver_discount_percent },
    col2: { disabled: !transport_id, calculated_client_total, customer_discount_percent }
  }

  return (
    <Component {...mergedProps} {...props} />
  )
}
export default withContainer
